import menu from './en-US/menu';
import pages from './en-US/pages';

export default {
  'navBar.lang': 'Languages',
  ...menu,
  ...pages,
};
